import React from 'react';
import {View} from 'react-native';

import VerifyMobileIcon from '../../../images/brand/svg/icons/VerifyMobile.svg';
import { AccountScreenAction } from '../../../models/navigationTypes';
import Text from '../../themed/Text';

export default function AskToVerify({action}: {action: AccountScreenAction}) {
  return (
    <View
      style={{
        flexDirection: 'row',
        marginTop: -8,
        alignItems: 'center',
      }}>
      <View style={{paddingLeft: 4, paddingRight: 6}}>
        <VerifyMobileIcon width={17} height={30} />
      </View>
      <Text variant="body2">
        {action === AccountScreenAction.UPDATE && 'If you have changed your mobile number '}
        we will ask to verify your mobile number through a verification code in
        the next step
      </Text>
    </View>
  );
}
